// Full bilingual content for the CMIC site.

const currentYear = new Date().getFullYear();

const ROUTES_ES = {
  home: '',
  about: 'quienes-somos',
  directory: 'directorio',
  membership: 'membresia',
  periodicals: 'publicaciones',
  news: 'noticias',
  events: 'eventos',
  resources: 'recursos',
  contact: 'contacto',
  gallery: 'galeria',
  profile: 'mi-perfil',
  privacy: 'aviso-de-privacidad',
};

const ROUTES_EN = {
  home: '',
  about: 'about-us',
  directory: 'directory',
  membership: 'membership',
  periodicals: 'periodicals',
  news: 'news',
  events: 'events',
  resources: 'resources',
  contact: 'contact',
  gallery: 'gallery',
  profile: 'my-profile',
  privacy: 'privacy',
};

export const es = {
  locale: 'es',
  routes: ROUTES_ES,
  nav: {
    home: 'Inicio', about: 'Quiénes Somos', directory: 'Directorio',
    membership: 'Membresía', periodicals: 'Periodicals', news: 'Noticias',
    events: 'Eventos', resources: 'Recursos', contact: 'Contacto',
    gallery: 'Galería', past_presidents_photos: 'Fotos Ex-Presidentes',
  },
  hero: {
    since: 'Fundado en 1982',
    titleLine1: 'Colegio Mexicano de',
    titleLine2: 'Intérpretes de Conferencias',
    tagline: 'Un Colegio que nos une, una profesión que nos enorgullece.',
    description: 'Comunidad profesional comprometida con la excelencia, la ética y el crecimiento continuo de la interpretación de conferencias en México.',
    ctaDirectory: 'Directorio de Intérpretes',
    ctaMembership: 'Hazte Miembro',
  },
  history: {
    title: 'Nuestra Historia',
    photoCaption: 'Fundación del Colegio Mexicano de Intérpretes de Conferencias (1982)',
    introParagraphs: [
      'En 1982, la interpretación de conferencias en México estaba bien establecida y, gracias al profesionalismo y la calidad de la(o)s intérpretes que trabajaban en este campo, era una actividad que gozaba de gran prestigio. Sin embargo, hacía falta una organización que aglutinara al gremio y dentro de la cual se intercambiaran experiencias, se propiciara el diálogo que ayudara a consolidar condiciones de trabajo dignas de observancia general y se marcara la pauta para el desarrollo de la profesión en nuestro país.',
      'Éste fue el espíritu que motivó a Sergio Alarcón, entonces un joven intérprete, a convocar a sus colegas de distintos grupos y generaciones a una reunión en Cocoyoc, Morelos. En la fotografía oficial del evento podemos ver una afortunada mezcla de intérpretes, desde Italia Morayta, pionera de la interpretación en México, hasta quienes, recién graduados, estaban empezando una prometedora carrera.',
      'De esa reunión surgió el Colegio Mexicano de Intérpretes de Conferencias, A.C. (CMIC), una asociación de profesionales que comparten un código común de ética y condiciones de trabajo y que se rigen por estatutos y reglamentos aprobados por mayoría. El órgano supremo del CMIC es la Asamblea General, que tiene entre sus funciones renovar el consejo directivo y las distintas comisiones, recibir los informes de los distintos órganos de la agrupación y aprobar los planes de trabajo para el año siguiente.',
    ],
    commissionsTitle: 'Actualmente, las comisiones permanentes del CMIC son las siguientes:',
    commissions: [
      'Admisiones, reclasificaciones, bajas y trayectoria profesional',
      'Vinculación, tecnología y educación',
      'Solidaridad', 'Editorial', 'Honor y justicia', 'Estatutos y reglamentos',
    ],
    midParagraphs: [
      'Desde su fundación, el CMIC opera con el trabajo no remunerado de quienes lo integran. Gracias al empeño de la membresía hemos logrado el registro como asociación civil, la revisión profesional de nuestra normatividad, la realización de distintos eventos, convenciones y cursos de capacitación y educación continua, la integración de un seguro de gastos médicos mayores y un acervo editorial, en el que destacan nuestros boletines periódicos Flash y Le Petit Journal du CMIC (2017-2019), la revista Los lenguas —que se publica en ocasiones especiales para cubrir un tema específico—, nuestros blogs y libros, el más ambicioso sin lugar a dudas Tras las huellas de una profesión, obra fruto de un proyecto de historia oral que recupera y contextualiza la memoria de los protagonistas de la interpretación en México.',
      'Además, se reconoce con un fistol de plata a la(o)s intérpretes que cumplen 25 años de ejercicio profesional y a quienes cumplen medio siglo de trayectoria laboral se les suele rendir un homenaje.',
    ],
    malintzinHighlight: 'En 1994, a iniciativa de nuestro colega Héctor Acosta, el CMIC estableció el Premio Malintzin\u00AE como un reconocimiento bienal a un(a) miembro de la profesión que sobresalga de sus pares por su ética, profesionalismo, solidaridad y compañerismo. Aunque cualquier miembro del CMIC puede postular a alguien, no es requisito pertenecer a la asociación para ser postulado(a). La decisión recae en un jurado electo con ese fin por la Asamblea General.',
    socialParagraph: 'Debe destacarse la importante actividad social del CMIC. Hemos realizado numerosas actividades para fortalecer los lazos de unión dentro del gremio: homenajes, obras de teatro, pastorelas y funciones de ballet, cenas, comidas, bailes y brindis de fin de año (en 2020 en modalidad virtual, por razones obvias). También hemos organizado ventas de cochera para apoyar a colegas en apuros, ventas de glosarios para enriquecer nuestro acervo y hasta de recetarios de cocina que han servido para dejar constancia de la diversidad de origen en nuestras filas.',
    solidaridadHighlight: 'El Fondo de Solidaridad es uno de los mayores orgullos del CMIC. Creado en 1986 a iniciativa de Nina Marentes con un monto inicial de $5,000.00 MXN, el Fondo ha multiplicado significativamente su capital y ha brindado ayuda económica a un gran número de miembros cuando lo han necesitado por razones de salud o de índole financiera.',
    closingParagraphs: [
      'Cada uno de los consejos directivos ha llevado al CMIC un paso adelante en la consecución de sus objetivos iniciales y lo ha ido transformando para que sus miembros puedan hacer frente a las necesidades del mercado, que ha tenido giros inesperados, como la introducción de nuevas tecnologías que recibieron un impulso sin precedentes durante la pandemia de COVID-19.',
      'A lo largo de cuatro décadas, cada miembro ha aportado sus ideas y sus particulares maneras de ver e interpretar la profesión para que el CMIC se nutra, crezca y siga consolidándose como la asociación que reúne a los pilares de la interpretación en México y a las nuevas generaciones de intérpretes profesionales de nuestro país.',
    ],
  },
  about: {
    label: 'Quiénes Somos', title: 'Bienvenidos al CMIC', historyTitle: 'Nuestra Historia',
    p1: 'El Colegio Mexicano de Intérpretes de Conferencias es una comunidad profesional fundada en 1982 que reúne a intérpretes de conferencias comprometidos con la excelencia, la ética y el crecimiento continuo de nuestra profesión en México.',
    p2: 'Creemos en el poder de la comunicación entre lenguas y culturas, y en la responsabilidad que implica ejercer esta profesión con preparación, integridad y sensibilidad. Desde el CMIC trabajamos para fortalecer el prestigio de la interpretación profesional, promover altos estándares de calidad y acompañar el desarrollo de quienes la ejercemos.',
    quote: 'Más que una asociación, el CMIC es un espacio de encuentro, colaboración y pertenencia. Aquí compartimos experiencias, nos apoyamos mutuamente y construimos juntos el presente y el futuro de nuestra profesión.',
    valuesTitle: 'Misión, Visión y Valores',
    valuesSubtitle: 'Los pilares que guían nuestro ejercicio profesional y nuestro compromiso con la comunidad.',
    values: [
      { title: 'Ética Profesional', description: 'Ejercemos nuestra profesión con integridad, confidencialidad y responsabilidad.' },
      { title: 'Excelencia', description: 'Buscamos los más altos estándares de calidad en la interpretación de conferencias.' },
      { title: 'Comunidad', description: 'Nos apoyamos mutuamente y construimos juntos el presente y futuro de nuestra profesión.' },
      { title: 'Visibilidad', description: 'Trabajamos para fortalecer el prestigio y reconocimiento de la interpretación profesional.' },
    ],
    presLabel: 'Mensaje de la Presidencia',
    presTitle: 'Es un honor servir al CMIC en esta nueva etapa.',
    presP1: 'Asumo esta responsabilidad con profundo respeto por la historia de nuestro Colegio y por quienes lo han construido a lo largo de los años. También con entusiasmo por lo que podemos seguir construyendo juntos: un CMIC cercano a su membresía, activo, visible y unido.',
    presP2: 'Creemos en una comunidad profesional que se acompaña, se fortalece y se reconoce mutuamente. Nuestro compromiso es cuidar lo que hemos logrado, abrir espacios de participación y seguir elevando el valor de la interpretación de conferencias en México con una visión moderna, colaborativa y humana.',
    boardTitle: 'Consejo Directivo',
    boardMembers: [
      { role: 'Presidente', name: 'Lorenia Rincón', photo: '/consejo/lorenia-rincon.jpeg' },
      { role: 'Vicepresidente', name: 'Raquel Dubrovsky', photo: '/consejo/raquel-dubrovsky.jpeg' },
      { role: 'Secretaria', name: 'Verónica Méndez', photo: '/consejo/veronica-mendez.jpeg' },
      { role: 'Tesorera', name: 'Laura Castro', photo: '/consejo/laura-castro.jpeg' },
      { role: 'Tesorera', name: 'Gabriela Durazo', photo: '/consejo/gabriela-durazo.jpeg' },
      { role: 'Vocal', name: 'Roberto Rivero', photo: '/consejo/roberto-rivero.jpeg' },
    ],
    presQuote: '"Sigamos haciendo del CMIC un espacio que nos represente, nos una y nos proyecte con orgullo."',
    presName: 'Lorenia Rincón del Ángel Rizo',
    presRole: 'Presidente - Colegio Mexicano de Intérpretes de Conferencias',
    statutesTitle: 'Estatutos del CMIC',
    statutesDescription: 'Consulta el documento fundacional con las normas de organización y funcionamiento del Colegio Mexicano de Intérpretes de Conferencias.',
    statutesButton: 'Descargar Estatutos (PDF)',
  },
  directory: {
    label: 'Directorio', title: 'Directorio de Intérpretes',
    subtitle: 'Encuentre intérpretes de conferencias profesionales certificados por el CMIC. Todos nuestros miembros activos están comprometidos con los más altos estándares de calidad.',
    searchPlaceholder: 'Nombre o palabra clave', languagePlaceholder: 'Ej: Inglés, Francés',
    specialtyPlaceholder: 'Ej: Derecho, Medicina',
    searchLabel: 'Buscar', languageLabel: 'Idioma', specialtyLabel: 'Especialidad',
    loading: 'Cargando directorio...',
    found: (n) => `${n} intérprete${n !== 1 ? 's' : ''} encontrado${n !== 1 ? 's' : ''}`,
    emptyTitle: 'El directorio se encuentra en actualización.',
    emptySubtitle: 'Pronto estará disponible el listado de intérpretes activos.',
    noResultsTitle: 'No se encontraron resultados para su búsqueda.',
    noResultsSubtitle: 'Intente con otros términos de búsqueda.',
    profile: {
      languageCombinations: 'Combinación Lingüística', about: 'Semblanza',
      references: 'Certificaciones', contactInfo: 'Información de Contacto',
      backToDirectory: 'Volver al Directorio', viewLinkedIn: 'Ver perfil en LinkedIn',
      notFound: 'Intérprete no encontrado',
      notFoundSub: 'El perfil que busca no existe o ya no está disponible.',
    },
  },
  membership: {
    label: 'Membresía', title: 'Únete al CMIC',
    subtitle: 'Forma parte de la comunidad de intérpretes de conferencias más importante de México.',
    admissionsTitle: 'Admisiones',
    admissionsIntro: '¿Estás estudiando interpretación? ¿Apenas estás incursionando en el ámbito profesional? ¿Tienes ya largos años de experiencia como intérprete de conferencias? Si te interesa sumarte al Colegio Mexicano de Intérpretes de Conferencias, A.C. –la asociación profesional que, desde su fundación en 1982, ha contado en sus filas con los representantes más destacados de la profesión en México–, en esta sección encontrarás información de utilidad. Tu participación en nuestra comunidad es muy valiosa y tenemos diferentes categorías de miembro para que puedas integrarte.',
    whatItMeansTitle: '¿Qué significa ser miembro del CMIC?',
    whatItMeans: [
      'Adquirir un sentido de pertenencia a nuestra profesión.',
      'Ampliar el alcance de nuestra red de contactos profesionales.',
      'Intercambiar ideas y experiencias con nuestros pares.',
      'Acercarnos a distintas generaciones de profesionales y aprender de ellas.',
      'Contar con el respaldo de una asociación profesional que avala nuestra capacidad y nos apoya cuando lo necesitamos.',
      'Disfrutar de un seguro grupal de gastos médicos con precios preferenciales y tener acceso al Fondo de Solidaridad.',
      'Tener mayor visibilidad ante posibles contratantes.',
    ],
    wantToKnowMore: '¿Quieres saber más?',
    wantToKnowMoreText: 'Te invitamos a descargar nuestro reglamento, donde puedes consultar los requisitos de admisión, o a ponerte en contacto con nosotros.',
    downloadRegulations: 'Descargar Reglamento',
    admissionsEmail: 'admisiones@cmicmexico.org',
    types: [
      { title: 'Miembro Activo', description: 'Intérpretes de conferencias con experiencia comprobada.', features: ['Aparición en el Directorio de Intérpretes', 'Voto en Asamblea General', 'Acceso a eventos exclusivos', 'Red de contactos profesionales', 'Respaldo institucional del CMIC'] },
      { title: 'Miembro Aspirante', description: 'Intérpretes en formación o con experiencia inicial.', features: ['Acceso a eventos y capacitaciones', 'Mentoría de miembros activos', 'Participación en la comunidad', 'Desarrollo profesional continuo'] },
    ],
    benefitsTitle: 'Beneficios de ser parte del CMIC',
    benefits: [
      { title: 'Red Profesional', text: 'Forma parte de una comunidad de intérpretes comprometidos con la excelencia.' },
      { title: 'Desarrollo Continuo', text: 'Acceso a capacitaciones, talleres y recursos para crecer profesionalmente.' },
      { title: 'Reconocimiento', text: 'Respaldo institucional que avala tu profesionalismo ante clientes y organizaciones.' },
      { title: 'Visibilidad', text: 'Presencia en el directorio consultado por organizaciones nacionales e internacionales.' },
    ],
    requirementsTitle: 'Requisitos e Ingreso',
    requirementsP1: 'Para solicitar ingreso al CMIC, los candidatos deben cumplir con los requisitos establecidos en nuestros estatutos, los cuales incluyen formación profesional en interpretación de conferencias y experiencia comprobable en el ejercicio de la profesión.',
    requirementsP2: 'El proceso de admisión contempla la revisión del perfil profesional del candidato y, en su caso, una evaluación por parte del Consejo Directivo.',
    ctaInfo: 'Solicitar Información', ctaStatutes: 'Ver Estatutos',
  },
  news: {
    label: 'Noticias y Comunidad', title: 'Actividades y Comunicados',
    subtitle: 'Mantente al día con las actividades del CMIC, nuestra participación en la FIT y comunicados relevantes para la comunidad.',
    loading: 'Cargando noticias...', readMore: 'Leer más',
    emptyTitle: 'Próximamente publicaremos noticias y comunicados.',
    emptySubtitle: 'Mantente al pendiente de las actividades del CMIC.',
    filterAll: 'Todas',
    categories: { actividad: 'Actividad', fit: 'FIT', comunicado: 'Comunicado', evento: 'Evento' },
  },
  events: {
    label: 'Eventos', title: 'Próximos Eventos',
    subtitle: 'Participa en nuestras actividades, talleres y encuentros profesionales.',
    loading: 'Cargando eventos...', scheduled: 'Eventos Programados', register: 'Registro',
    past: 'Eventos Anteriores', emptyTitle: 'No hay eventos programados por el momento.',
    emptySubtitle: 'Los próximos eventos del CMIC se publicarán aquí.',
  },
  resources: {
    label: 'Recursos', title: 'Recursos Profesionales',
    subtitle: 'Material útil para el ejercicio profesional de la interpretación de conferencias.',
    docsTitle: 'Documentos y Material',
    documents: [
      { title: 'Código de Ética', description: 'Principios y normas que rigen el ejercicio profesional de los intérpretes del CMIC.' },
      { title: 'Buenas Prácticas', description: 'Guía de mejores prácticas para la interpretación de conferencias profesional.' },
      { title: 'Estatutos del CMIC', description: 'Documento fundacional con las normas de organización y funcionamiento del Colegio.' },
      { title: 'Documentos Institucionales', description: 'Reglamentos, actas y demás documentos oficiales del CMIC.' },
    ],
    orgsTitle: 'Organizaciones Afines',
    orgs: [
      { name: 'FIT', fullName: 'Fédération Internationale des Traducteurs', description: 'Federación Internacional de Traductores, de la cual el CMIC es miembro.' },
      { name: 'AIIC', fullName: 'Association Internationale des Interprètes de Conférence', description: 'Asociación Internacional de Intérpretes de Conferencias.' },
      { name: 'ONU', fullName: 'Naciones Unidas - Interpretación', description: 'Recursos de interpretación de las Naciones Unidas.' },
    ],
  },
  contact: {
    label: 'Contacto', title: 'Contáctanos',
    subtitle: 'Estamos aquí para responder tus preguntas. Escríbenos y nos pondremos en contacto contigo.',
    infoTitle: 'Información de Contacto', emailLabel: 'Correo institucional',
    socialTitle: 'Redes Sociales',
    infoNote: 'Para consultas sobre membresía, directorio de intérpretes o colaboraciones institucionales, no dudes en escribirnos. Responderemos a la brevedad.',
    form: { name: 'Nombre', email: 'Correo electrónico', subject: 'Asunto', message: 'Mensaje',
      send: 'Enviar Mensaje', sending: 'Enviando...',
      success: 'Mensaje enviado correctamente. Gracias por contactarnos.',
      error: 'Hubo un error. Por favor, intenta de nuevo.' },
  },
  login: {
    title: 'Acceso al Portal', subtitle: 'Inicia sesión con tu cuenta del CMIC',
    usernameLabel: 'Usuario', passwordLabel: 'Contraseña', submit: 'Iniciar Sesión',
    back: 'Volver al sitio', hint: 'Si no tienes cuenta, contacta al administrador del CMIC.',
    error: 'Credenciales incorrectas. Verifica tu usuario y contraseña.',
  },
  portal: {
    welcome: 'Bienvenido', myProfile: 'Mi Perfil', saveChanges: 'Guardar Cambios',
    saving: 'Guardando...', saved: 'Cambios guardados correctamente.', logout: 'Cerrar sesión',
    fields: { full_name: 'Nombre completo', languages: 'Idiomas', city: 'Ciudad',
      email: 'Correo electrónico', phone: 'Teléfono', specialty: 'Especialidad',
      bio: 'Biografía', linkedin_url: 'LinkedIn URL', language_pairs: 'Combinaciones lingüísticas',
      references_text: 'Referencias', photo_url: 'URL de foto' },
  },
  footer: {
    description: 'Colegio Mexicano de Intérpretes de Conferencias A.C. Comunidad profesional fundada en 1982, comprometida con la excelencia y la ética en la interpretación de conferencias en México.',
    motto: '"Un Colegio que nos une, una profesión que nos enorgullece."',
    institutional: 'Institucional', community: 'Comunidad', memberAccess: 'Acceso Miembro',
    copyright: `${currentYear} Colegio Mexicano de Intérpretes de Conferencias A.C. Todos los derechos reservados.`,
    fitMember: 'Miembro de la FIT - Fédération Internationale des Traducteurs',
  },
  hub: {
    title: 'Hub Interno',
    subtitle: 'Noticias, eventos, avisos y foro del Colegio Mexicano de Intérpretes de Conferencias — solo para miembros activos.',
    privateLabel: 'Espacio privado del Colegio',
    tabs: { news: 'Noticias internas', events: 'Eventos internos', notices: 'Avisos', forum: 'Foro' },
    create: { news: 'Nueva noticia', events: 'Nuevo evento', notices: 'Nuevo aviso', forum: 'Nueva categoría' },
    notices: {
      empty: 'No hay avisos por el momento.',
      firstAction: 'Publicar el primer aviso',
      pinned: 'Fijado',
      expires: 'Expira',
      titleField: 'Título', bodyField: 'Contenido (HTML permitido)',
      pinToggle: 'Fijar arriba', expiresField: 'Expira (opcional)',
      bodyPlaceholder: 'Escribe el cuerpo del aviso…',
    },
  },
  security: {
    pageTitle: 'Preguntas de seguridad',
    pageDescription: 'Configura 2 preguntas secretas para poder recuperar tu contraseña si pierdes acceso al correo. Tus respuestas se guardan cifradas y no son visibles ni siquiera para los administradores.',
    configured: 'Ya tienes preguntas configuradas. Puedes actualizarlas a continuación si lo deseas.',
    chooseQuestion: '— Elige una pregunta —',
    answerHint: 'Las respuestas son insensibles a mayúsculas y acentos.',
    confirmPassword: 'Confirma tu contraseña actual',
    saveButton: 'Guardar preguntas',
    savedSuccess: 'Preguntas guardadas correctamente.',
    recoverTitle: 'Recuperación por preguntas',
    recoverSubtitle: 'Responde tus 2 preguntas de seguridad para crear una nueva contraseña sin pasar por el correo.',
    recoverIntro: 'Si la cuenta existe y configuró preguntas, te mostramos sus 2 preguntas a continuación. Responde ambas correctamente para cambiar tu contraseña.',
    forgotLink: 'Recuperar con preguntas de seguridad',
    backToEmail: 'Volver a recuperar por correo',
    success: 'Contraseña actualizada. Te redirigiremos al inicio de sesión.',
  },
  captcha: { incomplete: 'Por favor completa la verificación anti-bots.' },
  catalogs: {
    title: 'Catálogos', subtitle: 'Administra los idiomas y especialidades disponibles para los perfiles de intérpretes.',
    tabs: { languages: 'Idiomas', specialties: 'Especialidades' },
    add: 'Agregar', rename: 'Renombrar', merge: 'Fusionar', delete: 'Eliminar',
    splitButton: 'Dividir todo automáticamente',
    blobBannerTitle: 'Hay {n} valor(es) "compuestos" en los perfiles',
    blobBannerHelp: 'Al dividir, se actualizan automáticamente todos los perfiles que las usen.',
    countCol: 'Intérpretes', valueCol: 'Valor', noUse: 'sin uso',
    searchPlaceholder: 'Buscar…',
  },
};

export const en = {
  locale: 'en',
  routes: ROUTES_EN,
  nav: { home: 'Home', about: 'About Us', directory: 'Directory', membership: 'Membership',
    periodicals: 'Periodicals', news: 'News', events: 'Events', resources: 'Resources', contact: 'Contact',
    gallery: 'Gallery', past_presidents_photos: 'Past Presidents Photos' },
  hero: {
    since: 'Founded in 1982', titleLine1: 'Mexican College of', titleLine2: 'Conference Interpreters',
    tagline: 'A College that unites us, a profession that makes us proud.',
    description: 'Professional community committed to excellence, ethics, and the continuous growth of conference interpreting in Mexico.',
    ctaDirectory: 'Interpreters Directory', ctaMembership: 'Become a Member',
  },
  history: {
    title: 'Our History',
    photoCaption: 'Founding of the Mexican College of Conference Interpreters (1982)',
    introParagraphs: [
      'In 1982, conference interpreting in Mexico was well established and, thanks to the professionalism and quality of the interpreters working in this field, it was an activity that enjoyed great prestige. However, an organization was needed to bring the profession together, exchange experiences, foster dialogue to consolidate dignified working conditions of general observance, and set the pace for the development of the profession in our country.',
      'This was the spirit that motivated Sergio Alarcon, then a young interpreter, to invite his colleagues from different groups and generations to a meeting in Cocoyoc, Morelos. In the official photograph of the event, we can see a fortunate mix of interpreters, from Italia Morayta, a pioneer of interpretation in Mexico, to those who, newly graduated, were beginning a promising career.',
      'From that meeting emerged the Mexican College of Conference Interpreters, A.C. (CMIC), an association of professionals who share a common code of ethics and working conditions and who are governed by statutes and regulations approved by majority. The supreme body of CMIC is the General Assembly, whose functions include renewing the board of directors and the various commissions, receiving reports from the different bodies of the organization, and approving work plans for the following year.',
    ],
    commissionsTitle: 'Currently, the permanent commissions of CMIC are the following:',
    commissions: ['Admissions, reclassifications, departures and professional trajectory',
      'Outreach, technology and education', 'Solidarity', 'Editorial',
      'Honor and justice', 'Statutes and regulations'],
    midParagraphs: [
      'Since its founding, CMIC operates through the unpaid work of its members. Thanks to the dedication of the membership, we have achieved registration as a civil association, professional review of our regulations, the realization of various events, conventions and continuing education courses, the integration of a major medical insurance plan, and an editorial collection that includes our periodic newsletters Flash and Le Petit Journal du CMIC (2017-2019), the magazine Los lenguas, our blogs and books.',
      'Additionally, interpreters who complete 25 years of professional practice are recognized with a silver pin, and those who complete half a century of professional career are usually honored.',
    ],
    malintzinHighlight: 'In 1994, at the initiative of our colleague Hector Acosta, CMIC established the Malintzin\u00AE Prize as a biennial recognition of a member of the profession who stands out among their peers for their ethics, professionalism, solidarity, and collegiality. Although any CMIC member can nominate someone, it is not a requirement to belong to the association to be nominated. The decision rests with a jury elected for that purpose by the General Assembly.',
    socialParagraph: 'The important social activity of CMIC deserves special mention. We have carried out numerous activities to strengthen bonds within the profession: tributes, plays, pastorelas, ballet performances, dinners, lunches, dances, and end-of-year toasts.',
    solidaridadHighlight: 'The Solidarity Fund is one of CMIC\'s greatest prides. Created in 1986 at the initiative of Nina Marentes with an initial amount of $5,000.00 MXN, the Fund has significantly multiplied its capital and has provided financial assistance to a large number of members when they have needed it for health or financial reasons.',
    closingParagraphs: [
      'Each board of directors has taken CMIC one step forward in achieving its initial objectives and has transformed it so that its members can meet the needs of the market, which has had unexpected turns, such as the introduction of new technologies that received an unprecedented boost during the COVID-19 pandemic.',
      'Over four decades, each member has contributed their ideas and their particular ways of seeing and interpreting the profession so that CMIC nourishes itself, grows, and continues to consolidate as the association that brings together the pillars of interpreting in Mexico and the new generations of professional interpreters in our country.',
    ],
  },
  about: {
    label: 'About Us', title: 'Welcome to CMIC', historyTitle: 'Our History',
    p1: 'The Mexican College of Conference Interpreters is a professional community founded in 1982 that brings together conference interpreters committed to excellence, ethics, and the continuous growth of our profession in Mexico.',
    p2: 'We are colleagues who believe in the power of communication between languages and cultures, and in the responsibility that comes with practicing this profession with preparation, integrity, and sensitivity.',
    quote: 'More than an association, CMIC is a space for encounter, collaboration, and belonging. Here we share experiences, support each other, and together build the present and future of our profession.',
    valuesTitle: 'Mission, Vision & Values',
    valuesSubtitle: 'The pillars that guide our professional practice and commitment to the community.',
    values: [
      { title: 'Professional Ethics', description: 'We practice our profession with integrity, confidentiality, and responsibility.' },
      { title: 'Excellence', description: 'We seek the highest quality standards in conference interpreting.' },
      { title: 'Community', description: 'We support each other and together build the present and future of our profession.' },
      { title: 'Visibility', description: 'We work to strengthen the prestige and recognition of professional interpretation.' },
    ],
    presLabel: 'Message from the President',
    presTitle: 'It is an honor to serve CMIC in this new chapter.',
    presP1: 'I take on this responsibility with deep respect for the history of our College and for those who have built it over the years. Also with enthusiasm for what we can continue building together: a CMIC close to its membership, active, visible, and united.',
    presP2: 'We believe in a professional community that accompanies, strengthens, and recognizes each other. Our commitment is to care for what we have achieved, open spaces for participation, and continue elevating the value of conference interpreting in Mexico with a modern, collaborative, and human vision.',
    boardTitle: 'Board of Directors',
    boardMembers: [
      { role: 'President', name: 'Lorenia Rincón', photo: '/consejo/lorenia-rincon.jpeg' },
      { role: 'Vice President', name: 'Raquel Dubrovsky', photo: '/consejo/raquel-dubrovsky.jpeg' },
      { role: 'Secretary', name: 'Verónica Méndez', photo: '/consejo/veronica-mendez.jpeg' },
      { role: 'Treasurer', name: 'Laura Castro', photo: '/consejo/laura-castro.jpeg' },
      { role: 'Treasurer', name: 'Gabriela Durazo', photo: '/consejo/gabriela-durazo.jpeg' },
      { role: 'Member at Large', name: 'Roberto Rivero', photo: '/consejo/roberto-rivero.jpeg' },
    ],
    presQuote: '"Let us continue making CMIC a space that represents us, unites us, and projects us with pride."',
    presName: 'Lorenia Rincón del Ángel Rizo',
    presRole: 'President - Mexican College of Conference Interpreters',
    statutesTitle: 'CMIC Statutes',
    statutesDescription: 'Review the founding document with the organizational and operational rules of the Mexican College of Conference Interpreters.',
    statutesButton: 'Download Statutes (PDF)',
  },
  directory: {
    label: 'Directory', title: 'Interpreters Directory',
    subtitle: 'Find professional conference interpreters certified by CMIC. All our active members are committed to the highest quality standards.',
    searchPlaceholder: 'Name or keyword', languagePlaceholder: 'E.g.: English, French',
    specialtyPlaceholder: 'E.g.: Law, Medicine',
    searchLabel: 'Search', languageLabel: 'Language', specialtyLabel: 'Specialty',
    loading: 'Loading directory...',
    found: (n) => `${n} interpreter${n !== 1 ? 's' : ''} found`,
    emptyTitle: 'The directory is currently being updated.',
    emptySubtitle: 'The list of active interpreters will be available soon.',
    noResultsTitle: 'No results found for your search.',
    noResultsSubtitle: 'Try different search terms.',
    profile: {
      languageCombinations: 'Language Combinations', about: 'Biography',
      references: 'Certifications', contactInfo: 'Contact Information',
      backToDirectory: 'Back to Directory', viewLinkedIn: 'View LinkedIn Profile',
      notFound: 'Interpreter not found',
      notFoundSub: 'The profile you are looking for does not exist or is no longer available.',
    },
  },
  membership: {
    label: 'Membership', title: 'Join CMIC',
    subtitle: 'Become part of the most important conference interpreters community in Mexico.',
    admissionsTitle: 'Admissions',
    admissionsIntro: 'Are you studying interpreting? Are you just entering the professional field? Do you already have years of experience as a conference interpreter? If you are interested in joining the Mexican College of Conference Interpreters, A.C., in this section you will find useful information. Your participation in our community is very valuable and we have different membership categories so you can join.',
    whatItMeansTitle: 'What does it mean to be a CMIC member?',
    whatItMeans: [
      'Acquire a sense of belonging to our profession.',
      'Expand the reach of our professional contact network.',
      'Exchange ideas and experiences with our peers.',
      'Connect with different generations of professionals and learn from them.',
      'Have the support of a professional association that endorses our capabilities and supports us when we need it.',
      'Enjoy group medical insurance at preferential rates and access to the Solidarity Fund.',
      'Have greater visibility among potential clients.',
    ],
    wantToKnowMore: 'Want to know more?',
    wantToKnowMoreText: 'We invite you to download our regulations, where you can consult the admission requirements, or to contact us.',
    downloadRegulations: 'Download Regulations',
    admissionsEmail: 'admisiones@cmicmexico.org',
    types: [
      { title: 'Active Member', description: 'Conference interpreters with proven experience.', features: ['Listing in the Interpreters Directory', 'Voting rights at the General Assembly', 'Access to exclusive events', 'Professional networking', 'Institutional endorsement by CMIC'] },
      { title: 'Aspiring Member', description: 'Interpreters in training or with initial experience.', features: ['Access to events and training', 'Mentorship from active members', 'Community participation', 'Continuous professional development'] },
    ],
    benefitsTitle: 'Benefits of being part of CMIC',
    benefits: [
      { title: 'Professional Network', text: 'Be part of a community of interpreters committed to excellence.' },
      { title: 'Continuous Development', text: 'Access to training, workshops, and resources for professional growth.' },
      { title: 'Recognition', text: 'Institutional endorsement that validates your professionalism before clients and organizations.' },
      { title: 'Visibility', text: 'Presence in the directory consulted by national and international organizations.' },
    ],
    requirementsTitle: 'Requirements & Admission',
    requirementsP1: 'To apply for CMIC membership, candidates must meet the requirements established in our statutes, which include professional training in conference interpreting and demonstrable experience in the practice of the profession.',
    requirementsP2: 'The admission process includes a review of the candidate\'s professional profile and, where applicable, an evaluation by the Board of Directors.',
    ctaInfo: 'Request Information', ctaStatutes: 'View Statutes',
  },
  news: {
    label: 'News & Community', title: 'Activities & Announcements',
    subtitle: 'Stay up to date with CMIC activities, our participation in FIT, and relevant announcements for the community.',
    loading: 'Loading news...', readMore: 'Read more',
    emptyTitle: 'News and announcements coming soon.',
    emptySubtitle: 'Stay tuned for CMIC activities.',
    filterAll: 'All',
    categories: { actividad: 'Activity', fit: 'FIT', comunicado: 'Announcement', evento: 'Event' },
  },
  events: {
    label: 'Events', title: 'Upcoming Events',
    subtitle: 'Participate in our activities, workshops, and professional meetings.',
    loading: 'Loading events...', scheduled: 'Scheduled Events', register: 'Register',
    past: 'Past Events', emptyTitle: 'No events currently scheduled.',
    emptySubtitle: 'Upcoming CMIC events will be posted here.',
  },
  resources: {
    label: 'Resources', title: 'Professional Resources',
    subtitle: 'Useful materials for the professional practice of conference interpreting.',
    docsTitle: 'Documents & Materials',
    documents: [
      { title: 'Code of Ethics', description: 'Principles and standards governing the professional practice of CMIC interpreters.' },
      { title: 'Best Practices', description: 'Guide to best practices for professional conference interpreting.' },
      { title: 'CMIC Statutes', description: 'Founding document with the organizational and operational rules of the College.' },
      { title: 'Institutional Documents', description: 'Regulations, minutes, and other official CMIC documents.' },
    ],
    orgsTitle: 'Affiliated Organizations',
    orgs: [
      { name: 'FIT', fullName: 'Fédération Internationale des Traducteurs', description: 'International Federation of Translators, of which CMIC is a member.' },
      { name: 'AIIC', fullName: 'Association Internationale des Interprètes de Conférence', description: 'International Association of Conference Interpreters.' },
      { name: 'UN', fullName: 'United Nations - Interpretation', description: 'United Nations interpretation resources.' },
    ],
  },
  contact: {
    label: 'Contact', title: 'Contact Us',
    subtitle: 'We are here to answer your questions. Write to us and we will get back to you.',
    infoTitle: 'Contact Information', emailLabel: 'Institutional email',
    socialTitle: 'Social Media',
    infoNote: 'For inquiries about membership, interpreters directory, or institutional collaborations, please write to us. We will respond promptly.',
    form: { name: 'Name', email: 'Email', subject: 'Subject', message: 'Message',
      send: 'Send Message', sending: 'Sending...',
      success: 'Message sent successfully. Thank you for contacting us.',
      error: 'There was an error. Please try again.' },
  },
  login: {
    title: 'Portal Access', subtitle: 'Sign in with your CMIC account',
    usernameLabel: 'Username', passwordLabel: 'Password', submit: 'Sign In',
    back: 'Back to site', hint: 'If you do not have an account, contact the CMIC administrator.',
    error: 'Invalid credentials. Please check your username and password.',
  },
  portal: {
    welcome: 'Welcome', myProfile: 'My Profile', saveChanges: 'Save Changes',
    saving: 'Saving...', saved: 'Changes saved successfully.', logout: 'Sign out',
    fields: { full_name: 'Full name', languages: 'Languages', city: 'City',
      email: 'Email', phone: 'Phone', specialty: 'Specialty', bio: 'Biography',
      linkedin_url: 'LinkedIn URL', language_pairs: 'Language pairs',
      references_text: 'References', photo_url: 'Photo URL' },
  },
  footer: {
    description: 'Mexican College of Conference Interpreters A.C. Professional community founded in 1982, committed to excellence and ethics in conference interpreting in Mexico.',
    motto: '"A College that unites us, a profession that makes us proud."',
    institutional: 'Institutional', community: 'Community', memberAccess: 'Member Access',
    copyright: `${currentYear} Mexican College of Conference Interpreters A.C. All rights reserved.`,
    fitMember: 'Member of FIT - Fédération Internationale des Traducteurs',
  },
  hub: {
    title: 'Internal Hub',
    subtitle: 'News, events, notices and forum of the Mexican College of Conference Interpreters — members only.',
    privateLabel: 'Private members area',
    tabs: { news: 'Internal news', events: 'Internal events', notices: 'Notices', forum: 'Forum' },
    create: { news: 'New news', events: 'New event', notices: 'New notice', forum: 'New category' },
    notices: {
      empty: 'No notices at the moment.',
      firstAction: 'Publish the first notice',
      pinned: 'Pinned',
      expires: 'Expires',
      titleField: 'Title', bodyField: 'Content (HTML allowed)',
      pinToggle: 'Pin to top', expiresField: 'Expires (optional)',
      bodyPlaceholder: 'Write the notice body…',
    },
  },
  security: {
    pageTitle: 'Security questions',
    pageDescription: 'Set up 2 secret questions so you can recover your password if you lose access to your email. Your answers are encrypted and not visible to administrators.',
    configured: 'You already have questions configured. You can update them below if you wish.',
    chooseQuestion: '— Choose a question —',
    answerHint: 'Answers are case-insensitive and accent-insensitive.',
    confirmPassword: 'Confirm your current password',
    saveButton: 'Save questions',
    savedSuccess: 'Questions saved successfully.',
    recoverTitle: 'Question-based recovery',
    recoverSubtitle: 'Answer your 2 security questions to set a new password without going through email.',
    recoverIntro: 'If the account exists and has questions set up, you will see its 2 questions below. Answer both correctly to change your password.',
    forgotLink: 'Recover with security questions',
    backToEmail: 'Back to recover via email',
    success: 'Password updated. Redirecting you to sign in.',
  },
  captcha: { incomplete: 'Please complete the anti-bot verification.' },
  catalogs: {
    title: 'Catalogs', subtitle: 'Manage the languages and specialties available for interpreter profiles.',
    tabs: { languages: 'Languages', specialties: 'Specialties' },
    add: 'Add', rename: 'Rename', merge: 'Merge', delete: 'Delete',
    splitButton: 'Split everything automatically',
    blobBannerTitle: 'There are {n} "compound" value(s) in profiles',
    blobBannerHelp: 'Splitting automatically updates every profile that uses them.',
    countCol: 'Interpreters', valueCol: 'Value', noUse: 'unused',
    searchPlaceholder: 'Search…',
  },
};

export const SUPPORTED_LOCALES = ['es', 'en'];
export const DEFAULT_LOCALE = 'es';
const localeMap = { es, en };

export function getTranslations(locale) {
  return localeMap[locale] || localeMap[DEFAULT_LOCALE];
}
export function isValidLocale(value) {
  return SUPPORTED_LOCALES.includes(value);
}
export function buildLocalePath(locale, routeKey) {
  const t = getTranslations(locale);
  const slug = t.routes[routeKey];
  return `/${locale}${slug ? `/${slug}` : ''}`;
}

// ---- Dynamic overrides (admin TranslationsPage) ----

// Flatten a nested object to dot-notation keys; ONLY strings are flattened.
// Arrays, functions, and complex objects are skipped (not editable in v1).
export function flattenStrings(obj, prefix = '', acc = {}) {
  if (!obj || typeof obj !== 'object') return acc;
  for (const k of Object.keys(obj)) {
    const val = obj[k];
    const path = prefix ? `${prefix}.${k}` : k;
    if (typeof val === 'string') {
      acc[path] = val;
    } else if (val && !Array.isArray(val) && typeof val === 'object') {
      flattenStrings(val, path, acc);
    }
  }
  return acc;
}

// Set a dot-notation path on a clone of the source object. Returns a new object.
function setDeep(target, path, value) {
  const parts = path.split('.');
  let cur = target;
  for (let i = 0; i < parts.length - 1; i++) {
    const k = parts[i];
    if (cur[k] == null || typeof cur[k] !== 'object' || Array.isArray(cur[k])) return target;
    cur[k] = { ...cur[k] };
    cur = cur[k];
  }
  const last = parts[parts.length - 1];
  if (typeof cur[last] === 'string') {
    cur[last] = value;
  }
  return target;
}

function cloneDeep(value) {
  return JSON.parse(JSON.stringify(value, (_k, v) => (typeof v === 'function' ? null : v)));
}

// Merge backend overrides ({key: {es, en}}) on top of static translations.
// Returns a new translations object (does not mutate originals).
export function mergeOverrides(locale, overrides) {
  const base = getTranslations(locale);
  if (!overrides || Object.keys(overrides).length === 0) return base;
  // Clone JSON-serializable parts; we need to preserve function fields like directory.found.
  const cloned = { ...base };
  // Deep-clone only sub-objects that we may touch (string-bearing). Easiest: shallow clone + setDeep clones path.
  for (const key of Object.keys(overrides)) {
    const ov = overrides[key];
    const val = ov && typeof ov === 'object' ? ov[locale] : null;
    if (typeof val === 'string' && val.length > 0) {
      setDeep(cloned, key, val);
    }
  }
  return cloned;
}
